import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { InputAdornment, TextField, Box, Typography } from '@mui/material';
import { numberWithCommas, toEnglishNumber } from '../../utils/formatNumber';
import { useTranslation } from 'react-i18next';
import Num2persian from 'num2persian';
import { tomanPrice } from '../../utils/functions';

RHFCurrencyField.propTypes = {
  name: PropTypes.string,
};

export default function RHFCurrencyField({ name, sx, convert = false, disabled, inputMode, type, ...other }) {
  const { control, setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const persianText = convert
          ? `${Num2persian(tomanPrice(getValues(name)))} تومان`
          : null;

        return (
          <Box sx={{ width: '100%' }}>
            <TextField
              {...field}
              fullWidth
              error={!!error}
              {...other}
              value={numberWithCommas(getValues(name))}
              onChange={(event) => {
                let onlyNums = event.target.value.replace(/(?!,)[^0-9]$/g, '');
                onlyNums = toEnglishNumber(onlyNums);
                setValue(name, onlyNums.replaceAll(',', ''));
              }}
              sx={sx}
              inputMode={inputMode}
              type={type}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {t('currency')}
                  </InputAdornment>
                ),
              }}
              disabled={disabled}
            />

            {convert && persianText && (
              <Box
                sx={{
                  mt: 0.75,
                  px: 1.5,
                  py: 0.75,
                  backgroundColor: 'action.hover',
                  borderRadius: 1,
                  border: '1px dashed',
                  borderColor: 'divider',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.secondary',
                    fontSize: '0.72rem',
                    lineHeight: 1.4,
                    direction: 'rtl',
                    fontWeight: 500,
                  }}
                >
                  {persianText}
                </Typography>
              </Box>
            )}

            {error?.message && (
              <Typography
                variant="caption"
                sx={{ color: 'error.main', mt: 0.5, px: 1.75, display: 'block' }}
              >
                {error.message}
              </Typography>
            )}
          </Box>
        );
      }}
    />
  );
}